import { LogLevel, ILogTags, ILog } from '@agoda/messaging-client';
import { ActivitiesMessagingClient } from 'core/messaging/ActivitiesMessagingClient';
import { href } from 'core-framework/window/location';
import { getBootstrapConfig, getIsJestTest } from 'core/window/windowService';
import { getMandatoryMeasurementTags } from 'core/service/measurements/measurementUtils';

const NoStringLogTags = {};
const NoAnyLogTags = {};

const sendLogMessage = (
    logLevel: LogLevel,
    logMessage: string,
    pageTypeId: number,
    customTags: ILogTags<string> = NoStringLogTags,
    eventData: ILogTags<unknown> = NoAnyLogTags,
) => {
    const config = getBootstrapConfig();
    const baseTags = getMandatoryMeasurementTags(config);
    const { correlationId, ...restCustomTags } = customTags;
    const payload: ILog = {
        level: logLevel,
        message: logMessage,
        applicationName: 'activities',
        loggerName: 'Fe.Messaging.Logger',
        url: href(),
        countryOfOrigin: config.pageConfig.origin || '',
        callerModuleId: pageTypeId || 0,
        sessionId: config.sessionId ? config.sessionId.toString() : 'unknown',
        correlationID: correlationId ?? config.correlationId,
        botName: baseTags.botName,
        stringTags: { pageTypeId: String(pageTypeId), version: config.version, ...baseTags, ...restCustomTags },
        eventdata: { ...eventData },
    };

    try {
        const message = ActivitiesMessagingClient.create('log', payload);
        ActivitiesMessagingClient.send(message);
    } catch (e) {
        // Failed to log the message. We do not have any fallback mechanism.
    }
};

export const logDebug = (message: string, pageTypeId: number, customTags: ILogTags<string> = NoStringLogTags, eventData: ILogTags<unknown> = NoAnyLogTags) => {
    sendLogMessage('debug', message, pageTypeId, customTags, eventData);
};

export const logInfo = (message: string, pageTypeId: number, customTags: ILogTags<string> = NoStringLogTags, eventData: ILogTags<unknown> = NoAnyLogTags) => {
    sendLogMessage('info', message, pageTypeId, customTags, eventData);
};

export const logWarn = (message: string, pageTypeId: number, customTags: ILogTags<string> = NoStringLogTags, eventData: ILogTags<unknown> = NoAnyLogTags) => {
    sendLogMessage('warn', message, pageTypeId, customTags, eventData);
};

export const logError = (message: string, pageTypeId: number, customTags: ILogTags<string> = NoStringLogTags, eventData: ILogTags<unknown> = NoAnyLogTags) => {
    if (window && !getIsJestTest()) {
        console.error && console.error(message, eventData?.error || '');
    }
    sendLogMessage('error', message, pageTypeId, customTags, eventData);
};

export const logFatal = (message: string, pageTypeId: number, customTags: ILogTags<string> = NoStringLogTags, eventData: ILogTags<unknown> = NoAnyLogTags) => {
    sendLogMessage('fatal', message, pageTypeId, customTags, eventData);
};
